<div class="d-inline-flex align-items-end" [ngStyle]="cpWidth ? {'width':cpWidth}: ''">

  <beaconstac-textfield
    (textChange)="toggleColorPicker()"
    (keydown)="$event.preventDefault();"
    [(colorPicker)]="color"
    class="cursor-pointer"
    [style.width]="cpWidth ? '100%': ''"
    [label]="label"
    [title]="title"
    [id]="id"
    [disabled]="disabled"
    [cpDisabled]="disabled"
    [style.cursor]="'pointer'"
    (colorPickerChange)="colorPickerChanged($event)"
    [cpPosition]="cpPosition"
    [cpPositionRelativeToArrow]="true"
    [cpAlphaChannel]="cpAlphaChannel"
    [cpOutputFormat]="cpOutputFormat"
    [maxWidth]="width"
    [placeholder]="color"
    [cpPresetColors]="presetColors"
    (cpPresetColorsChange)="handlePresetColorChange($event)"
    [cpAddColorButton]="enableAddColorBtn"
    [readonly]="readonly"
    [disableValidator]="disableValidator"
  >
  </beaconstac-textfield>

  <div (click)="toggleColorPicker()" class="ml-2 color-picker-box">
    <div class="color-picker-body" [ngStyle]="{background: color}" [ngClass]="disabled ? 'cursor-not-allowed' : 'cursor-pointer'">
    </div>
  </div>
</div>
